<template src="./Drivers.html">
</template>

<script>
import { getDrivers } from '@/services/driver'
import Details from './Details'

export default {
  name: 'Drivers',
  data () {
    return {
      drivers: []
    }
  },
  components: {
    Details
  },
  mounted () {
    this.loadDrivers()
  },
  methods: {
    loadDrivers () {
      getDrivers()
        .then(res => {
          this.drivers = res.data
        })
    },
    gotoEditDriver (item) {
      this.$router.push({ name: 'UserAddEdit', params: { id: item.id } })
    },
    gotoAddDriver () {
      this.$router.push('/admin/users/add')
    }
  }
}
</script>

<style lang="scss" scoped>
.drivers {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  align-item: center;
}
@media screen and (max-width: 600px){
  .drivers {
    display: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/driver/Drivers.vue